
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC09UiYBNnFo2IOhKorQ8gK9e32SKaugm0",
  authDomain: "dukana-4a6ee.firebaseapp.com",
  projectId: "dukana-4a6ee",
  storageBucket: "dukana-4a6ee.appspot.com",
  messagingSenderId: "744361727903",
  appId: "1:744361727903:web:529f55ebd6da6cb0ee0faa",
  measurementId: "G-0H57EQ03T1"
};

//firebase.initializeApp(firebaseConfig);
let messaging = getMessaging(initializeApp(firebaseConfig));

//const { REACT_APP_VAPID_KEY } = process.env;
const publicKey = "BHw7L5OzPdjCRGcKZ9ZnMBQTj1gs3Z3rnFEBgdeeTU28wmcT9ah2CfaJg0VhYM_8mCHpK8Trk8Q4rsNb3wlA9wM";

export const getTokens = async (setTokenFound) => {
  let currentToken = "";

  try {
    currentToken = await getToken(messaging,{ vapidKey: publicKey });
    if (currentToken) {
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
  } catch (error) {
    console.log("An error occurred while retrieving token. ", error);
  }

  return currentToken;
};

